import { useEffect } from "react";

export function useInterval(callback: () => void, ms = 1000): void {
  useEffect(() => {
    callback();
    const interval = setInterval(callback, ms);

    return () => clearInterval(interval);
  }, [callback, ms]);
}
